import Analytics, { AnalyticsInstance } from 'analytics';
// @ts-ignore
import googleAnalyticsPlugin from '@analytics/google-analytics';
import { useState } from 'react';

let analytics: AnalyticsInstance | null = null;
const initialize = () => {
  if (!analytics) {
    try {
      analytics = Analytics({
        app: process.env.REACT_APP_ANALYTICS_APP_NAME,
        debug: true,
        plugins: [
          googleAnalyticsPlugin({
            measurementIds: [process.env.REACT_APP_GA_MEASUREMENT_ID],
            gtagConfig: {
              send_page_view: true,
              debug_mode: true,
            },
          }),
        ],
      });
      // @ts-ignore
      window.analytics = analytics;
    } catch (e) {
      console.error(e);
    }
  }
  return analytics;
};

const useAnalytics = () => {
  const [analyticsInstance, setAnalyticsInstance] = useState(initialize());
  return analyticsInstance;
};

export {
  useAnalytics,
  initialize as analytics,
};
